import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setLanguage } from 'redux-i18n';
import moment from 'moment';
import base64 from 'base-64';

import { setBookingData, enableFreeMode } from 'bookingform';
import {
  setShowDistributions,
  setfiltercurrencycode,
  setAgentCode as setAgentCodeInBookingForm,
  setAgentSell as setAgentSellInBookingForm,
  setRateType as setRateTypeInBookingForm,
  setAgentUseCoins as setAgentUseCoinsInBookingForm,
  setOrigin,
} from 'bookingform/dist/export/actions';
import {
  BOOKING_STEP,
  getBookingDetail,
  injectGoogleMaps,
  sendBookingDetailLink,
  sendGTMEvents,
  setBookEmail,
  setBookLocator,
  setStep,
  bookingAdyenPay,
  getCartShare,
  setHotel,
  setLastRequestedInfo,
  setCurrencies,
  setFilterCurrency,
  findHotelDestination,
  setAgentCode,
  setRateType,
  setAgentSell,
  setAgentUseCoins,
  setCoinsUsedInEditingBooking,
  setDingusCustomerCodeUsedInEditingBooking,
  setEditBookingToken,
  setEditBooking,
  DEVICES,
  setMultipleRoomStep,
  setClientIpCountryCode,
} from '../../../actions/Booking';
import {
  getMemberInfo,
  setCoinsApplied,
  setCoinsEntered,
  setMaxCoinsToApply,
  setMaxPercentUsage,
  logout,
  setNewMember,
  setNewMemberDiscountPercentage,
  setSaNetRatePercentage,
} from '../../../actions/Loyalty';
import { setCartUpdating, updateCartContent, emptyShoppingCart } from '../../../actions/Cart';
import { CALL_CENTER_ROLE, TPV_FORM_ADYEN } from '../../../constants';
import { paymentCreatedEvent, sendSimpleGAEvent } from '../../../events/Booking';

import CallCenterBookingOptions from './CallCenterBookingOptions';
import BookingLoadingScreen from './BookingLoadingScreen';

import '../../../static/less/pages/booking_details.less';
import '../../../static/images/mapicohotel.png';
import '../../../static/images/loading4.gif';

import DsMap from '../../ds/atoms/map';
import ReservationDetailsBlock from '../rooms/ReservationDetailsBlock';
import DsLoadingScreen from '../../ds/atoms/loading/index';
import Transfers from '../Transfers';
import '../../../static/less/rooms/complete_adyen_payment.less';
import withNavigate from '../../../withNavigate'; // Importa el HOC
import GreetingClient from '../edit-bookings/GreetingClient';
import BookingOverview from '../edit-bookings/BookingOverview';
import { isValidAge } from '../../../utils/Room';

const cartRoomToDistribution = (hotel, cartRoom) => {
  const { use } = cartRoom;
  const children = use.ages.filter((age) => isValidAge(hotel, 'children', age)).length;
  return { adl: use.adults, chd: children, enf: use.childs - children };
};

class BookingDetails extends React.Component {
  constructor(props) {
    super(props);
    const query = new URLSearchParams(this.props.location.search);

    this.state = {
      booking: null,
      adyenInitialized: false,
      pageStatus: 'loading',
      guestEditModal: { show: false },
      active: 'Rooms',
      roomGuests: [],
      query,
      showCompleteAdyenPayment: false,
    };
    this.buildShareVoucherLink = this.buildShareVoucherLink.bind(this);
    this.createAdyenWidget = this.createAdyenWidget.bind(this);
  }

  async loadAdyenWidget() {
    // Llamar a èsto despuès de unos segundos de que se cargò elc artshare
    const { booking, adyenInitialized } = this.state;
    const isBookingPending = this.isBookingPending();

    if (isBookingPending && booking.locator && booking.cli_email
      && !adyenInitialized && booking.payment_method_code === 'ADYEN') {
      this.setState({ showCompleteAdyenPayment: true });
      await this.createAdyenWidget(booking.locator, booking.cli_email);
    }
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.bookingContactInformationHasBeenEdited !== this.props.bookingContactInformationHasBeenEdited) {
      this.initialize();
    }
  }

  initialize() {
    let locator;
    let email;
    let lang;
    const { params } = this.props;

    if (params && params.locator && params.email) {
      locator = base64.decode(params.locator);
      email = base64.decode(params.email);
      lang = params.lang;
      // eslint-disable-next-line no-console
      console.log('locator:');
      // eslint-disable-next-line no-console
      console.log(locator);
      // eslint-disable-next-line no-console
      console.log('email:');
      // eslint-disable-next-line no-console
      console.log(email);
    } else if (this.props.locator && this.props.email) {
      locator = this.props.locator;
      email = this.props.email;
      lang = this.props.lang;
    }

    if (locator && email) {
      if (lang && lang !== this.props.lang) {
        this.props.dispatch(setLanguage(lang));
        moment.locale(lang);
      }
      if (this.props.editBooking != null && this.props.editBooking.agent_code != null
        && this.props.editBooking.agent_code !== ''
        && this.props.editBooking.agent_sell != null && this.props.editBooking.agent_sell === true
        && this.props.editBooking.who_is_viewing === 'AGENT') {
        email = this.props.editBooking.agent_email;
      }
      this.loadBooking(locator, email, lang);
      this.props.dispatch(setStep(BOOKING_STEP.NO_AVAIL_STEP));
      this.props.dispatch(injectGoogleMaps());
    } else {
      this.props.navigate('/');
    }
  }

  componentDidMount() {
    this.initialize();
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    const { lang } = nextProps;
    if (lang !== this.props.lang) {
      this.loadBooking(nextProps.locator, nextProps.email, lang);
      moment.locale(lang);
    }
  }

  loadBooking(locator, email, lang) {
    this.setState({ pageStatus: 'loading', booking: null });
    this.props.dispatch(getBookingDetail(lang, locator, 'email', email)).then((response) => {
      const { booking } = response;
      if (booking) {
        if (this.props.isCallCenterUser) {
          this.props.dispatch(enableFreeMode(true));
        }
        this.props.dispatch(emptyShoppingCart());
        this.props.dispatch(setBookLocator(locator));
        this.props.dispatch(setBookEmail(email));
        this.props.dispatch(setEditBookingToken(booking.edit_booking_token));
        this.props.dispatch(setEditBooking(booking));

        /*if (booking.customer_code.includes('CALLCENTER')) {
          this.props.navigate('/booking-detail-v1/');
          return;
        }*/
        this.onBookLoaded(booking);
        if (booking.edit_booking_token != null) {
          this.loadCartDetails(booking.edit_booking_token, booking.lang);
        } else {
          //this.props.navigate('/booking-detail-v1/');
        }
        /*setTimeout(() => {
          this.loadAdyenWidget();
        }, 3000);*/
      } else {
        this.setState({ pageStatus: 'error' });
      }
    });
  }

  loadCartDetails(token, lang) {
    this.setState({ pageStatus: 'loading' });
    this.props.dispatch(getCartShare(token, lang)).then((response) => {
      if (response && response.cart != null) {
        try {
          // First we make sure that the information is valid, so we load it on the different elements of the store
          this.loadCartShareDetails(response);
          // Since we could load all data, we can now set the cart on the state and proceed to Confirmation page
          this.props.dispatch(updateCartContent(response.cart));
          this.props.dispatch(setCartUpdating(false));
          this.loadAdyenWidget();
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error('Error obtaining the cart share');
        }
      } else {
        // Ya no mandamos a this.props.navigate('/booking-detail-v1/');
        this.props.navigate('/booking-detail-v1/');
        // Ya se solucionó el eror que había en getCartShare, ahora ya siempre mandaremos a booking-detail
      }
      this.setState({ pageStatus: false });
    });
  }

  loadCartShareDetails({
    availability, cart, agent_code, rate_type, agent_sell, agent_use_coins, client_ip_country_code,
  }) {
    // Obtaining information about the HOTEL
    const cartHotel = cart.hotels[0];
    const availHotel = { ...availability.availables[0] };
    const fullHotel = findHotelDestination(this.props.countries, availHotel.code);
    availHotel.pk = fullHotel.pk; // The PK is necessary for launching new availabilities
    // Obtaining information about the ROOMs, both in "roomChoice" and "distri" formats
    const cartRooms = cartHotel.rooms;
    const distris = cartRooms.map((cartRoom) => cartRoomToDistribution(availHotel, cartRoom));
    // Now we generate a map for the availability results, as each requested room has an entry on that map
    /*const hotelRooms = {};
    availHotel.rooms.forEach((hotelRoom) => {
      const roomId = hotelRoom.request_id;
      const roomList = hotelRooms[roomId] || [];
      roomList.push(hotelRoom);
      hotelRooms[roomId] = roomList;
    });*/
    //const hotelRooms = cartRooms;
    // Once we have all the information, we can set it on the store
    const lastRequest = availability.requested_info;
    this.props.dispatch(setLastRequestedInfo(lastRequest));
    // Acá debemos de traer el valor de agentCode, rateType, agentUseCoins y agentSell desde la bd
    // y setearlos acá para que cuando carge el link tenga esa información seteada
    this.props.dispatch(setBookingData({
      dest: fullHotel,
      checkIn: lastRequest.checkin,
      checkOut: lastRequest.checkout,
      promoCode: lastRequest.promocode || '',
      distributions: this.props.isCallCenterUser ? 'ANY' : distris,
      chain: this.props.chain,
      origin: this.props.origin,
    }));
    this.props.dispatch(setAgentCode(agent_code !== '-' ? agent_code : ''));
    this.props.dispatch(setRateType(rate_type));
    this.props.dispatch(setAgentUseCoins(agent_use_coins));
    this.props.dispatch(setAgentSell(agent_sell));
    this.props.dispatch(setAgentCodeInBookingForm(agent_code !== '-' ? agent_code : ''));
    this.props.dispatch(setRateTypeInBookingForm(rate_type));
    this.props.dispatch(setAgentUseCoinsInBookingForm(agent_use_coins));
    this.props.dispatch(setAgentSellInBookingForm(agent_sell));
    this.props.dispatch(setShowDistributions(false));
    // The hotel needs to be set after the destination is
    this.props.dispatch(setHotel(availHotel));
    // The initial currency will be the same as in the hotel
    const filterCurrency = availHotel.currencies.find((currency) => currency.code === availHotel.default_currency);
    this.props.dispatch(setCurrencies(availHotel.currencies));
    this.props.dispatch(setFilterCurrency(filterCurrency));
    this.props.dispatch(setfiltercurrencycode(filterCurrency.code));
    this.props.dispatch(setOrigin(this.props.origin ? this.props.origin : 'BOOKING'));
    this.props.dispatch(setClientIpCountryCode(client_ip_country_code));
  }

  async createAdyenWidget(locator, email) {
    if (this.state.adyenInitialized) return;
    this.setState({ adyenInitialized: true });
    try {
      const result = await this.props.dispatch(bookingAdyenPay(
        this.context,
        locator,
        email,
        TPV_FORM_ADYEN,
        this.props.navigate,
      ));
      if (result === 'ERR') {
        // eslint-disable-next-line no-console
        console.error('Error processing booking with Adyen.');
      } else {
        // eslint-disable-next-line no-console
        console.log('Adyen payment initialized successfully.');
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error in createAdyenWidget:', error);
    }
  }

  async checkMember(email, hotel_code) {
    const results = await this.props.dispatch(getMemberInfo({
      email,
      callcenter_email: 'test@example.com',
      hotel_code,
    }));
    if (results) {
      const { info } = results;
      if (info && info.discount_available_percentage) {
        this.props.dispatch(setMaxPercentUsage(info.discount_available_percentage));
      }
      this.props.dispatch(setNewMember(info.new_member)); //Establecemos si es un miembro nuevo de loyalty para que loyalty le pueda dar el 10% del costo de la reserva en coins
      this.props.dispatch(setNewMemberDiscountPercentage(info.new_member_discount_percentage));
      this.props.dispatch(setSaNetRatePercentage(info.sa_net_rate_percentage));
      //Acá debe ir lo mismo que en ReservationDetailsBlock y en RoomTile
      if (this.props.coinsUsedInEditingBooking > 0) {
        this.props.dispatch(setCoinsEntered(this.props.coinsUsedInEditingBooking));
        this.props.dispatch(setCoinsApplied(this.props.coinsUsedInEditingBooking));
        this.props.dispatch(setMaxCoinsToApply(this.props.coinsUsedInEditingBooking));
      }
    } else {
      this.props.dispatch(logout());
      if (this.props.coinsForRegistering > 0) {
        this.props.dispatch(setMaxCoinsToApply(this.props.coinsForRegistering));
      }
    }
  }

  renderTransfer(booking) {
    const { transfer } = booking; // eslint-disable
    if (!transfer) {
      return null;
    }

    const room = booking.rooms[0];
    const occupancy = this.getCombinedOccupancy(booking);
    return (
            <div className="row ThanksTransfers">
              <Transfers
                      checkin={room.check_in} checkout={room.check_out}
                      locator={booking.locator} lang={this.props.lang}
                      occupancy={occupancy} {...transfer} />
              <p>
                {this.context.t('You can also find bookable transfers in the email we just sent you')}
              </p>
            </div>
    );
  }

  onBookLoaded(booking) {
    let uniqueSeq = 0;
    // Seteamos lo siguiente para que aparezca en mobile no aparezca como si faltara por seleccionar cuartos
    this.props.dispatch(setMultipleRoomStep(booking.rooms.length));
    const roomGuests = booking.rooms.map((room, roomIndex) => room.occupants.map((occupant, occupantIndex) => {
      const nameTokens = occupant.name.replace(/\s+/g, ' ').split(' ');
      uniqueSeq += 1;
      return {
        // Fields that cannot be changed
        age: occupant.age,
        ptype: occupant.ptype,
        code: occupant.code,

        // Fields that identify the guest
        roomIndex,
        guestIndex: occupantIndex,
        uniqueSeq,

        // Editable fields
        idType: 'email',
        userId: '',
        name: nameTokens[0],
        surname: nameTokens[1],
        surname2: nameTokens[2],
      };
    }));
    this.setState({ booking, roomGuests, pageStatus: booking.status === 'PEND' ? 'pending' : false });

    // Guardamos cuántos coins usó la persona en su booking anterior que está editando
    this.props.dispatch(setCoinsUsedInEditingBooking(booking.loyalty.coins_used));
    this.props.dispatch(setDingusCustomerCodeUsedInEditingBooking(booking.customer_code));
    // Si no está logeado el usuario lo logeamos
    if (booking.loyalty.coins_used != null) {
      // Sólo logeamos al usuario cuando usó loyalty, porque también puede pasar
      // que un usuario hizo una reserva sin loyalty pero sí tiene cuenta, entonces
      // si no ponemos eso de coins_used!=null, lo intentaría logear y se mostraría
      // su loyalty card cuando en realidad no usó coins para la reserva
      if (booking.loyalty_user_email != null) {
        this.checkMember(booking.loyalty_user_email, booking.hotel.code);
      }
    }

    const isNewBooking = this.props.showThanks && !this.isBookingCancelled();

    if (isNewBooking) {
      try {
        const paymentEvent = paymentCreatedEvent(booking);
        this.props.dispatch(sendGTMEvents([paymentEvent], `Purchase Event: ${booking.locator}`));
      } catch (e) {
        Raven.captureException(`Purchase Event: ${booking.locator} : ${e}`);
      }
    }
  }

  isBookingCancelled() {
    const { booking } = this.state;
    if (!booking) {
      return false;
    }
    return booking.status === 'CANC' || booking.status === 'REV';
  }

  isBookingPending() {
    const { booking } = this.state;
    if (!booking) {
      return false;
    }
    return booking.status === 'PEND';
  }

  goToCancellation = () => {
    sendSimpleGAEvent('Cancel', 'Go to cancellation');
    this.props.navigate('/cancellation/');
  };

  /* eslint-disable max-len */
  shareVoucher = (url, email) => this.props.dispatch(sendBookingDetailLink(this.props.locator, this.props.email, email, this.props.lang))

  /* eslint-enable max-len */

  buildShareVoucherLink() {
    const baseURL = process.env[`${this.props.chain}_BOOKING`];
    let url = null;
    if (this.props.locator && this.props.email) {
      const locator = base64.encode(this.props.locator);
      const email = base64.encode(this.props.email);
      url = `${baseURL}/booking-detail/${locator}/${email}/${this.props.lang}/`;
    }
    return Promise.resolve(url || `${baseURL}/my-booking/`);
  }

  //****
  //**** RENDER*/
  //****

  renderMap(booking) {
    const hasLocation = booking && booking.hotel.position.latitude;
    if (!hasLocation) {
      return null;
    }
    const { latitude, longitude } = booking.hotel.position;
    return <DsMap latitude={latitude} longitude={longitude} className="h-40 w-40"/>;
  }

  renderCallCenterOptions(booking) {
    if (!this.props.isCallCenterUser) {
      return null;
    }
    return (
            <CallCenterBookingOptions booking={booking} locator={this.props.locator} lang={this.props.lang}/>
    );
  }

  onClose = () => {
    this.setState({ showCompleteAdyenPayment: false });
  };

  rendershowCompleteAdyenPaymentPayment() {
    const { showCompleteAdyenPayment } = this.state;
    if (showCompleteAdyenPayment === true) {
      return (
        // eslint-disable-next-line react/no-string-refs
        <div className="CompleteAdyenPayment animated bounceInLeft" ref="CompleteAdyenPayment"
        onClick={this.onClose}>
          <b>{this.context.t('The payment has not been completed. Please verify your information and try again.')}</b>
        </div>
      );
    }
    return null;
  }

  render() {
    const {
      pageStatus, booking,
    } = this.state;
    const {
      chain,
    } = this.props;
    const isLoading = pageStatus === 'loading';

    if (isLoading) {
      return (
              <DsLoadingScreen chain={chain}>
                <p>{this.context.t('Retrieving your booking...')}</p>
              </DsLoadingScreen>
      );
    }
    if (!booking) {
      return (
              <BookingLoadingScreen
                      mode={pageStatus}
                      onClickPay={this.goToPayment}
                      onClickCancel={this.goToCancellation}
                      onClickReload={this.loadBooking}
                      callCenterPhones={this.state.booking ? this.state.booking.hotel.chain.call_center_phones : null}
              />);
    }
    return (
            <div className="">
              <div className='row'>
                  {this.props.openReservationDetails === false
                   && <div className='col-xs-12 col-md-8 removeSpaceMd8 removeSpaceXs12'>
                        <h2 className="best-rate-option-title-margin-left-20px">{this.context.t('Guaranteed online best price!')}</h2>
                        <GreetingClient name={booking.cli_full_name} bookingStatus={this.state.booking.status}/>
                        {this.isBookingPending() && booking.payment_method_code === 'ADYEN'
                        && <>
                            <h5 className="text-2xl text-danger-200 text-left uppercase font-bold"
                            style={{ marginLeft: '20px', marginTop: '20px' }}>
                            {this.context.t('Pay now to confirm your booking')}
                            </h5>
                            <div id="dropin-container" className="py-3"></div>
                          </>
                        }
                        {/*<BoardDetailsBlock/>*/}
                        <BookingOverview/>
                        {this.renderCallCenterOptions(booking)}
                      </div>
                  }
                  {(this.props.isMobile === false || (this.props.isMobile === true
                    && this.props.openReservationDetails === true))
                    && <div className='col-xs-12 col-md-4 removeSpaceMd4 removeSpaceXs12'>
                      <ReservationDetailsBlock hotel_name={booking.hotel.name}
                        mostrarExtras={true}
                        checkIn={moment(booking.rooms[0].check_in).format('ll')}
                        checkOut={moment(booking.rooms[0].check_out).format('ll')}
                        bookNowTextButton={this.context.t('Continue')}
                        bookingStatus={booking.status}
                        hotelPhone={booking.hotel.phone}
                      />
                    </div>
                  }
              </div>
            </div>
    );
  }
}

BookingDetails.propTypes = {
  showThanks: PropTypes.bool,
  navigate: PropTypes.func.isRequired, // Prop para `navigate`
};

BookingDetails.contextTypes = {
  t: PropTypes.func.isRequired,
};

BookingDetails.defaultProps = {
  showThanks: false,
};

// Conectar el componente con Redux
const mapStateToProps = (state) => ({
  locator: state.booking.book_locator,
  email: state.booking.book_email,
  booking: state.booking.bookData,
  cartHotel: state.cart.cartHotel,
  device: state.booking.device,
  countries: state.bookingFormState.countries,
  origin: state.bookingFormState.origin,
  utmParams: state.bookingFormState.utmParams || {},
  isCallCenterUser: state.session.user.role === CALL_CENTER_ROLE,
  chainData: state.session.chainData,
  showEditBookingContactInformation: state.booking.showEditBookingContactInformation,
  bookingContactInformationHasBeenEdited: state.booking.bookingContactInformationHasBeenEdited,

  cart: state.cart,
  lang: state.i18nState.lang,
  loyalty: state.loyalty,
  chain: state.bookingFormState.chain,
  hotel: state.booking.hotel,
  selectedRoomDetail: state.booking.selectedRoomDetail,
  memberInfo: state.loyalty.memberInfo,
  selectedStatus: state.loyalty.selectedStatus,
  coinsForRegistering: state.loyalty.coinsForRegistering,
  coinsApplied: state.loyalty.coinsApplied,
  new_member: state.loyalty.newMember,
  new_member_discount_percentage: state.loyalty.newMemberDiscountPercentage,
  maxPercentUsage: state.loyalty.maxPercentUsage,
  userCurrency: state.booking.filterCurrency,
  amount: state.cart.amount,
  currency: state.cart.cartHotel.currency,
  callcenterUser: state.session.user,
  showLoyalty: state.session.chainData.loyalty_coins_active,
  new_member_discount_percentage_activated: state.booking.hotel != null
    ? (state.booking.hotel.new_member_discount_percentage_activated === true
      && state.bookingFormState.agentSell === 'false') : false,
  new_member_discount_percentage_chain: state.booking.hotel !== null
    ? state.session.chainData.loyalty_levels
      .find((member) => (member.membership_name === (state.bookingFormState.agentCode !== '' ? 'Blue Agent' : 'Blue')))
      .new_member_discount_percentage_hotels[state.booking.hotel.code.toLowerCase()]
    : 0,
  multipleRoomSelection: state.booking.multipleRoomSelection,
  conversionRates: state.loyalty.conversionRates,
  //currency: state.booking.filterCurrency,
  enteredCoins: state.loyalty.coinsEntered,
  maxCoinsToApply: state.loyalty.maxCoinsToApply,
  loggedUser: state.loyalty.loggedUser,
  distributions: state.bookingFormState.distributions.length > 0 ? state.bookingFormState.distributions
    : state.cart.cartHotel.rooms.map((room) => room.distribution),

  loyaltyName: state.session.chainData.booking_engine_configuration.loyalty_name,
  multipleRoomStep: state.booking.multipleRoomStep,
  nights: state.booking.last_requested_info.nights,
  coinsEntered: state.loyalty.coinsEntered,
  //isLoyaltyUserLoggedIn: isEmailPresent || isBecomeMemberStatus,
  isLoyaltyUserLoggedIn: state.loyalty.memberInfo ? !!state.loyalty.memberInfo.email : false,
  isCartUpdating: state.cart.isUpdating,
  currencies: state.booking.currencies,
  openReservationDetails: state.session.openReservationDetails,
  isMobile: state.booking.device === DEVICES.MOBILE,
  isTabletV: state.booking.device === DEVICES.TABLETV,
  isTabletH: state.booking.device === DEVICES.TABLETH,
  isDesktop: state.booking.device === DEVICES.DESKTOP,
  editBooking: state.booking.editBooking,
  coinsUsedInEditingBooking: state.booking.coinsUsedInEditingBooking,
});

const ConnectedBookingDetails = connect(mapStateToProps)(BookingDetails);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedBookingDetails);
